import { HEADER__column_right_default } from './HEADER__column_right_default';
import { HEADER__page_title } from './HEADER__page_title';

interface PROPS {
  column_left?: React.ReactNode;
  column_center?: React.ReactNode;
  column_right?: React.ReactNode;
}

export function HEADER__master({ column_left = <HEADER__page_title />, column_center = null, column_right = <HEADER__column_right_default /> }: PROPS) {
  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <header className="w-full h-16 min-h-16 bg-bar border-b border-component-border flex items-center justify-between relative  z-50">
      {column_left}

      <div className="h-full flex-1">{column_center}</div>

      {column_right}
    </header>
  );
}
